export const promiseWrapper = form => new Promise(resolve => {
    if (form && typeof form.validate === 'function') {
        form.validate(resolve)
    } else {
        // eslint-disable-next-line no-console
        // console.warn('请确认传入的参数是element-ui表单的实例')
        resolve(true)
    }
})

export const getFormsValidRes = async (...forms) => {
    const promiseArr = forms.map(form => promiseWrapper(form))
    const validArr = await Promise.all(promiseArr)
    return validArr.every(isValid => isValid)
}
